module.exports = __webpack_public_path__ + "static/categories_legend_in_template-c3eead9689667903ee69941cad13f538.png";